import styles from "./RouteError.module.css";

export const RouteError = () => {
    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Something went wrong</h2>
            <p className={styles.message}>Please try again. If the problem keeps happening, contact support.</p>
            <button className={styles.button} onClick={() => (window.location.href = "/")}>
                Reload
            </button>
        </div>
    );
};

export default RouteError;
